import PropTypes from 'prop-types';
import { useNavigate } from "react-router";
// material-ui
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// assets
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

export default function ProfileTab({ handleLogout, handleToggle }) {
  const navigate = useNavigate();
  const goToProfile = () => {
    navigate("/profile");
    if (handleToggle) handleToggle();
  };
  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      <ListItemButton onClick={goToProfile}>
        <ListItemText primary="User Profile" />
        <ListItemIcon>
          <UserOutlined />
        </ListItemIcon>
      </ListItemButton>

      <ListItemButton onClick={handleLogout}>
        <ListItemText primary="Logout" />
        <ListItemIcon>
          <LogoutOutlined />
        </ListItemIcon>
      </ListItemButton>
    </List>
  );
}

ProfileTab.propTypes = { handleLogout: PropTypes.func, handleToggle: PropTypes.func };
